"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvFromFileParser = void 0;
var ValidationError_1 = require("../ValidationError");
var fs_1 = require("fs");
var getEnvFromFileParser = function (envName, required) {
    if (required === void 0) { required = true; }
    return function () {
        var _a;
        var envValue = (_a = process.env[envName]) === null || _a === void 0 ? void 0 : _a.trim();
        if (!envValue || envValue.length === 0 || !fs_1.existsSync(envValue)) {
            if (!required) {
                return '';
            }
            throw new ValidationError_1.ValidationError("There is no file path stored in " + envName, envName);
        }
        return fs_1.readFileSync(envValue, 'utf-8').trim();
    };
};
exports.getEnvFromFileParser = getEnvFromFileParser;
